// logic
import { push } from 'connected-react-router';
import routes from 'utils/routes';
import { useDispatch } from 'react-redux';
// settings
import ticketFormSchema from './config/ticketFormSchema';
// service
import ticketService from '../../ticket-service';
import { useState } from 'react';

// returns ticketSettings with loading state
const useNewTicket = () => {
  const dispatch = useDispatch();

  const [newTicketInternalId, setNewTicketInternalId] = useState(1);
  const [createdTicket, setCreatedTicket] = useState(null);
  const [showConfirmation, setShowConfirmation] = useState(false);

  const validationSchema = ticketFormSchema;

  const initialValues =
    ticketService.defaultValues.getDefaultInitialFormValues();

  const isReadOnly = false;

  const isEdit = false;

  const onSubmit = async ({ ticketDto }) => {
    const response = await ticketService.callBackend.createNewTicket({
      ticketDto,
    });
    const createdTicket = response.data;
    setCreatedTicket(createdTicket);
    setShowConfirmation(true);
  };

  const onCancel = async () => {
    dispatch(push(`${routes.emergencies}/`));
  };

  const reset = () => {
    setNewTicketInternalId(newTicketInternalId + 1);
    setShowConfirmation(false);
  };

  return {
    createdTicket,
    validationSchema,
    initialValues,
    isReadOnly,
    isEdit,
    showConfirmation,
    onSubmit,
    onCancel,
    reset,
  };
};

export default useNewTicket;
